import { ErpOperationOutcomeTypeEnum } from "../../enum/erp-operation-outcome-type.enum.model";
import { ErpOperationTypeEnum } from "../../enum/erp-operation-type.enum.model";

export class OperationLogsModal {
  id?: number;
  mode: 'order' | 'fulfillment';

  constructor(init?: OperationLogsModal) {
    Object.assign(this, init);
  }
}

export class OperationLogDto {
  id: number;
  creatorEmail: string;
  creationTime: string;
  creatorId: number;
  operationType: ErpOperationTypeEnum;
  outcome: ErpOperationOutcomeTypeEnum;
  outcomeDetails: string;
  constructor(init?: OperationLogDto) {
    Object.assign(this, init);
  }
}
export class OrderOperationLogDto extends OperationLogDto {
  orderId: number;
  constructor(init?: OrderOperationLogDto) {
    super();
    Object.assign(this, init);
  }
}
export class FulfillmentOperationLogDto extends OperationLogDto {
  fulfillmentId: number;
  constructor(init?: FulfillmentOperationLogDto) {
    super();
    Object.assign(this, init);
  }
}


